import { MetaData, PdpMetaBuilderArgs } from "../types/seo-types";
import { Property } from "../types/property-types";
import { getPdpUrlById } from "../helpers/getPdpUrlById";

export const buildPdpMeta = async (
  property: Property,
  config: PdpMetaBuilderArgs,
): Promise<MetaData> => {
  return {
    metaTitle: await buildPdpMetaTitle(property, config),
    metaDescription: await buildPdpMetaDescription(property, config),
    metaCanonicalLink: getPdpUrlById(
      property.id,
      property.name,
      property.location?.city,
      property.location?.state,
    ),
    metaOgTitle: await buildPdpMetaOgTitle(property, config),
    metaOgType: config.ogType,
    metaOgDescription: await buildPdpMetaOgDescription(property, config),
    metaOgImage: await buildPdpMetaOgImage(property),
    metaOgUrl: getPdpUrlById(
      property.id,
      property.name,
      property.location?.city,
      property.location?.state,
    ),
  };
};

export const buildPdpMetaTitle = async (
  property: Property,
  config: PdpMetaBuilderArgs,
): Promise<string> => {
  return `${replaceTokens(property, config.metaTitleTemplate)}`;
};

export const buildPdpMetaDescription = async (
  property: Property,
  config: PdpMetaBuilderArgs,
): Promise<string> => {
  return replaceTokens(property, config.metaDescriptionTemplate);
};

export const buildPdpMetaOgTitle = async (
  property: Property,
  config: PdpMetaBuilderArgs,
): Promise<string> => {
  return replaceTokens(property, config.ogTitleTemplate);
};

export const buildPdpMetaOgDescription = async (
  property: Property,
  config: PdpMetaBuilderArgs,
): Promise<string> => {
  return replaceTokens(property, config.ogDescriptionTemplate);
};

export const buildPdpMetaOgImage = async (
  property: Property,
): Promise<string> => {
  return property.image?.url ?? "";
};

export const replaceTokens = (property: Property, template: string): string => {
  return template
    .replace("{name}", property.name ?? "")
    .replace("{city}", property.location?.city ?? "")
    .replace("{state}", property.location?.state ?? "")
    .replace("{postalcode}", property.location?.postalCode ?? "")
    .replace("{shortdescription}", property.about?.shortDescription ?? "");
};
